import {type FC, type ReactNode} from 'react';
import classNames from 'classnames';

import {useElevation} from '@time-webkit/all/hooks/elevation';
import {LEVEL} from '@time-webkit/all/hooks/elevation/src/constants';
import {Spinner} from '@time-webkit/all/atoms/spinner';

import styles from './auth-page-layout.module.css';

export type AuthPageLayoutProps = {
    footer?: ReactNode;
    paperClassName?: string;
    loading?: boolean;
    children?: ReactNode;
    leftTopActionButton?: ReactNode;
    rightTopActionButton?: ReactNode;
}

export const AuthPageLayout: FC<AuthPageLayoutProps> = ({
    footer,
    loading,
    children,
    paperClassName,
    leftTopActionButton,
    rightTopActionButton,
}) => {
    const elevationStyles = useElevation(LEVEL.FOUR);

    return (
        <div className={styles.root}>
            <div className={styles.container}>
                {leftTopActionButton && <div className={classNames(styles.actionButton, styles.leftActionButton)}>{leftTopActionButton}</div>}
                {rightTopActionButton && <div className={classNames(styles.actionButton, styles.rightActionButton)}>{rightTopActionButton}</div>}
                <main className={styles.main}>
                    {loading ? (
                        <Spinner />
                    ) : (
                        <div className={classNames(elevationStyles, styles.paper, paperClassName)}>
                            {children}
                        </div>
                    )}
                </main>
                {footer && <footer>{footer}</footer>}
            </div>
        </div>
    );
};
